import { render, staticRenderFns } from "./BoxArchive.vue?vue&type=template&id=1d91c543&"
import script from "./BoxArchive.vue?vue&type=script&lang=js&"
export * from "./BoxArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports